<template>

<svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M68 50L32 50" stroke="black" stroke-width="4" stroke-linejoin="round"/>
<path d="M50 68L50 32" stroke="black" stroke-width="4" stroke-linejoin="round"/>
<circle cx="50" cy="50" r="32" stroke="black" stroke-width="4"/>
</svg>

</template>
